<template>
  <div class="row" style="padding-bottom: 5px">
    <div class="col-xl-12">
      <nav class="nav nav-tabs partner-nav" id="nav-tab" role="tablist">
        <router-link to="/trip-request/partners-attendance" class="nav-link"
          >Attendance
        </router-link>

        <router-link to="/trip-request/partners/gas-bill/view" class="nav-link"
          >Gas Bill
        </router-link>

        <router-link to="/trip-request/partners/bill/view" class="nav-link"
          >Bill
        </router-link>

        <router-link
          to="/trip-request/partners/disbursement/view"
          :class="{
            'nav-link': true,
            active:
              pageName === 'Disbursement' || pageName === 'Disbursement Details'
          }"
          >Disbursement
        </router-link>
      </nav>
      <div class="search-bar">
        <div class="modality mb-3" v-if="pageName !== 'Disbursement Details'">
          <select class="form-select" v-model="modality">
            <option value="pool">Pool</option>
            <option value="fleet-fixed">Fleet Fixed</option>
            <option value="fleet-variable">Fleet Variable</option>
          </select>
        </div>
        <div
          class="button r mb-3"
          id="button-1"
          v-if="pageName !== 'Disbursement Details'"
        >
          <input
            v-if="canSwitchServiceType"
            type="checkbox"
            v-model="serviceTypeSwitch"
            class="checkbox"
          />
          <input
            v-else
            type="checkbox"
            style="cursor: not-allowed"
            v-model="fakeServiceTypeSwitch"
            class="checkbox"
            disabled
          />
          <div class="knobs"></div>
          <div class="layer"></div>
        </div>
        <div
          v-if="filterOptions"
          class="filter-section mb-3"
          style="float: left"
        >
          <button
            class="btn btn-secondary"
            id="filterButton"
            type="button"
            @click="showFilterOptions = !showFilterOptions"
          >
            <i class="bi bi-sliders"></i> Filter
            <span
              v-if="numOfCurrentFilters > 0"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
            >
              {{ numOfCurrentFilters }}
            </span>
          </button>
          <div v-if="showFilterOptions" id="filterPopUp" class="filter-pop-up">
            <div class="filter-pop-up-close">
              <i @click="showFilterOptions = false" class="bi bi-x-lg"></i>
            </div>
            <label for=""><b>Filter Options</b></label>
            <Multiselect
              :class="{
                'filter-fields': true,
                'filter-options': true,
                'ma-bo-120': filterOptOpen
              }"
              v-model="selectedFilters"
              mode="tags"
              :closeOnSelect="false"
              :searchable="true"
              :createTag="true"
              :options="filterOptions"
              :resetAfter="true"
              @open="filterOptOpen = true"
              @close="filterOptOpen = false"
              label="name"
              track-by="name"
              placeholder="Add Filter"
            />

            <!-- Attendance Page Filters Start -->
            <div v-if="selectedFilters.includes('name')">
              <label for="">Name</label>
              <input
                v-model.trim="filterValues.name"
                class="form-control filter-fields"
                placeholder="Name"
                @keydown.enter="search()"
              />
            </div>

            <div v-if="selectedFilters.includes('phone')">
              <label for="">Phone</label>
              <input
                v-model.trim="filterValues.phone"
                class="form-control filter-fields"
                placeholder="Mobile"
                @keydown.enter="search()"
              />
            </div>

            <div
              v-if="
                selectedFilters.includes('type') && pageName === 'Attendance'
              "
            >
              <label for="">Type</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.type"
                @keydown.enter="search()"
              >
                <option value="">Regular</option>
                <option value="backup">Backup</option>
              </select>
            </div>

            <div v-if="selectedFilters.includes('service_type')">
              <label for="">Service Type</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.service_type"
                @keydown.enter="search()"
              >
                <option value="B2B">B2B</option>
                <option value="B2C" selected>B2C</option>
              </select>
            </div>

            <div v-if="selectedFilters.includes('routeValue')">
              <label for="">Route</label>
              <Multiselect
                class="filter-fields"
                v-model="filterValues.routeValue"
                :closeOnSelect="true"
                :searchable="true"
                :options-limit="20"
                :options="routesOptions"
                :loading="true"
                placeholder="Select Route"
                @keydown.enter="search()"
              />
            </div>

            <div v-if="selectedFilters.includes('companyCode')">
              <label for="">Company Code</label>
              <Multiselect
                class="filter-fields"
                v-model="filterValues.companyCode"
                :closeOnSelect="true"
                :searchable="true"
                :options-limit="20"
                :options="companyCodes"
                :loading="true"
                placeholder="Select Company Code"
                @keydown.enter="search()"
              />
            </div>

            <div v-if="selectedFilters.includes('trId')">
              <label for="">TR Id</label>
              <Multiselect
                class="filter-fields"
                v-model="filterValues.trId"
                :closeOnSelect="true"
                :searchable="true"
                :options-limit="20"
                :options="TRIdList"
                :loading="true"
                placeholder="Select TR"
                @keydown.enter="search()"
              />
            </div>

            <div v-if="selectedFilters.includes('attendance_status')">
              <label for="">Verification Status</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.attendance_status"
                @keydown.enter="search()"
              >
                <option value="">ALL</option>
                <option value="Verified">Verified</option>
                <option value="Unverified">Unverified</option>
              </select>
            </div>

            <div
              v-if="
                selectedFilters.includes('bill_status') &&
                pageName === 'Attendance'
              "
            >
              <label for="">Bill Status</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.bill_status"
                @keydown.enter="search()"
              >
                <option value="NA">NA</option>
                <option value="Confirmed">Confirmed</option>
              </select>
            </div>
            <!-- Attendance Page Filters End -->

            <!-- Bill Page Filters Start -->
            <div v-if="selectedFilters.includes('type') && pageName === 'Bill'">
              <label for="">Bill Type</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.type"
                @keydown.enter="search()"
              >
                <option value="">Regular</option>
                <option value="gasbill">Gas Bill</option>
                <option value="backupbill">Backup Bill</option>
              </select>
            </div>
            <div v-if="selectedFilters.includes('account_no')">
              <label for="">Account No</label>
              <input
                v-model.trim="filterValues.account_no"
                class="form-control filter-fields"
                placeholder="Account No"
                @keydown.enter="search()"
              />
            </div>
            <div
              v-if="
                selectedFilters.includes('bill_status') && pageName === 'Bill'
              "
            >
              <label for="">Bill Status</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.bill_status"
                @keydown.enter="search()"
              >
                <option value="">--Select--</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Requested">Requested</option>
              </select>
            </div>
            <!-- Bill Page Filters End -->

            <!-- Disbursement Page Filters Start -->
            <div v-if="selectedFilters.includes('status')">
              <label for="">Filter Status</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.status"
                @keydown.enter="search()"
              >
                <option value="">--Select--</option>
                <option value="Disbursed">Disbursed</option>
                <option value="Partially Disbursed">Partially Disbursed</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
            <div v-if="selectedFilters.includes('downloadStatus')">
              <label for="">Download Status</label>
              <select
                class="form-select filter-fields"
                v-model="filterValues.downloadStatus"
                @keydown.enter="search()"
              >
                <option value="">--Select--</option>
                <option value="Downloaded">Downloaded</option>
                <option value="Pending">Pending</option>
              </select>
            </div>
            <!-- Disbursement Page Filters End -->

            <!-- Search Button -->
            <button @click="search()" class="btn btn-sm btn-primary">
              <i class="bi bi-search"></i> Search
            </button>
          </div>
        </div>
        <template v-if="pageName !== 'Disbursement Details'">
          <div
            v-if="selectedDate && modality === 'pool'"
            class="date-section mb-3"
          >
            <i @click="prevWeek" class="bi bi-chevron-left"></i>
            <Datepicker
              style="float: left"
              v-model="selectedDate"
              weekPicker
              range
              weekStart="4"
              :enableTimePicker="false"
              :clearable="false"
              hide-input-icon
              input-class-name="dp-custom-input"
            />
            <i @click="nextWeek" class="bi bi-chevron-right"></i>
          </div>
          <div v-else class="date-section mb-3">
            <i @click="prevMonth" class="bi bi-chevron-left"></i>
            <Datepicker
              style="float: left"
              v-model="selectedDate"
              month-picker
              :enableTimePicker="false"
              :clearable="false"
              hide-input-icon
              input-class-name="dp-custom-input"
            />
            <i @click="nextMonth" class="bi bi-chevron-right"></i>
          </div>
        </template>
        <button
          v-if="
            pageName == 'Attendance' &&
            filterOptions &&
            $userPermission.has('attendance-sync')
          "
          @click="$emit('sync')"
          :disabled="syncLoading"
          type="submit"
          class="btn btn-primary mb-3"
          id="syncButton"
        >
          <div
            v-if="syncLoading"
            class="spinner-border spinner-border-sm"
          ></div>
          <span v-if="syncLoading" class="px-1"> Syncing </span>
          <span v-else><i class="bi bi-arrow-repeat"></i> Sync </span>
        </button>
        <button
          v-if="
            pageName == 'Attendance' &&
            $userPermission.has('export-attendance-list')
          "
          @click="$emit('downloadExcel')"
          class="btn btn-success mb-3"
        >
          <i class="bi bi-file-earmark-spreadsheet-fill"></i>
        </button>
        <router-link
          v-if="pageName === 'Disbursement Details'"
          :to="`/trip-request/partners/disbursement/view/${$route.params.date}`"
          class="back-button mb-3"
          ><i class="bi bi-arrow-left"></i> Back</router-link
        >
        <button
          @click="windowLocationReload"
          type="button"
          class="btn btn-light"
          style="
            line-height: 15px;
            padding: 0;
            margin-top: 10px;
            margin-bottom: 26px;
          "
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import Datepicker from '@vuepic/vue-datepicker';
import { ref } from 'vue';

export default {
  components: {
    Multiselect,
    Datepicker
  },
  props: [
    'pageName',
    'date',
    'filterOptions',
    'routesOptions',
    'companyCodes',
    'TRIdList',
    'syncLoading'
  ],
  data() {
    return {
      spinnerLoading: false,
      selectedDate: null,
      dateRange: null,
      serviceTypeSwitch:
        localStorage.getItem('serviceType') == 'B2B' ? true : false,
      modality: localStorage.getItem('modality')
        ? localStorage.getItem('modality')
        : 'pool',
      fakeServiceTypeSwitch: false,
      showFilterOptions: false,
      selectedFilters: [],
      filterValues: {},
      numOfCurrentFilters: 0,
      filterOptOpen: false,
      canSwitchServiceType: true,
      modalityChanged: false
    };
  },
  watch: {
    selectedFilters: function () {
      this.filterValueMapping();
    },
    selectedDate: {
      handler: function () {
        this.createDateRange();
      },
      deep: true
    },
    serviceTypeSwitch: function () {
      this.removeRouteFilter();
      this.removeTRFilter();
      this.filterValueMapping();
      this.search();
    },
    modality() {
      this.modalityChanged = true;
      this.filterValueMapping();
      this.initDate();
      this.search();
    }
  },
  mounted() {
    // Hide filter box on clicking outside
    // let _this = this;
    // document.addEventListener('click', function (event) {
    //   if (
    //     !event.target.closest('#filterPopUp') &&
    //     !event.target.closest('#filterButton') &&
    //     !event.target.closest('.multiselect-tag-remove') &&
    //     !event.target.closest('.multiselect-option')
    //   ) {
    //     _this.showFilterOptions = false;
    //   }
    // });
    this.initDate();
    this.serviceTypePermissionCheck();
  },
  methods: {
    initDate() {
      if (this.modality === 'pool') {
        const date = ref();
        var newDate = new Date();
        if (
          newDate.getDay() === 4 &&
          this.pageName !== 'Disbursement Details'
        ) {
          newDate.setDate(newDate.getDate() - 1);
        }
        var daysToSub =
          newDate.getDay() > 3 ? newDate.getDay() - 4 : newDate.getDay() + 3;
        const startDate = new Date(
          newDate.setDate(newDate.getDate() - daysToSub)
        );
        const endDate = new Date(newDate.setDate(newDate.getDate() + 6));
        date.value = [startDate, endDate];
        this.selectedDate = date;
      } else {
        const date = ref({
          month: new Date().getMonth(),
          year: new Date().getFullYear()
        });
        this.selectedDate = date;
      }
    },
    createDateRange() {
      if (this.modality === 'pool' && this.selectedDate) {
        this.dateRange = this.selectedDate;
      } else {
        var d = new Date(this.selectedDate.year, this.selectedDate.month, 1),
          y = d.getFullYear(),
          m = d.getMonth();
        var firstDay = new Date(
          y,
          m,
          1,
          new Date().getHours(),
          new Date().getMinutes(),
          new Date().getSeconds()
        );
        var lastDay = new Date(
          y,
          m + 1,
          0,
          new Date().getHours(),
          new Date().getMinutes(),
          new Date().getSeconds()
        );
        this.dateRange = [firstDay, lastDay];
      }

      this.$emit('changeDate', this.dateRange, this.modalityChanged);
      if (this.modalityChanged) {
        this.modalityChanged = false;
      }
    },
    windowLocationReload() {
      window.location.reload();
    },
    serviceTypePermissionCheck() {
      this.canSwitchServiceType = true;

      if (
        this.$userPermission.has('attendance-b2b') &&
        !this.$userPermission.has('attendance-b2c')
      ) {
        this.serviceTypeSwitch = true;
        this.fakeServiceTypeSwitch = true;
        this.canSwitchServiceType = false;
      } else if (
        this.$userPermission.has('attendance-b2c') &&
        !this.$userPermission.has('attendance-b2b')
      ) {
        this.serviceTypeSwitch = false;
        this.fakeServiceTypeSwitch = false;
        this.canSwitchServiceType = false;
      }
    },
    filterValueMapping() {
      let oldFilterValues = this.filterValues;
      let oldFilterKeys = [];
      for (const key in this.filterValues) {
        oldFilterKeys.push(key);
      }
      this.filterValues = {};
    // console.log(this.selectedFilters)
      this.selectedFilters.forEach((ele) => {
        if (oldFilterKeys.includes(ele)) {
          this.filterValues[ele] = oldFilterValues[ele];
        } else {
          if (ele == 'service_type') {
            this.filterValues[ele] = 'B2C';
          } else if (ele == 'bill_status' && this.pageName === 'Attendance') {
            this.filterValues[ele] = 'NA';
          } else {
            this.filterValues[ele] = '';
          }
        }
      });
      if (this.serviceTypeSwitch) {
        localStorage.setItem('serviceType', 'B2B');
        this.filterValues['service_type'] = 'B2B';
      } else {
        localStorage.setItem('serviceType', 'B2C');
        this.filterValues['service_type'] = 'B2C';
      }
      localStorage.setItem('modality', this.modality);
      this.filterValues['modality'] = this.modality;
    },
    search() {
      this.numOfCurrentFilters = this.selectedFilters.length;
      this.$emit('filterSearch', this.filterValues);
      this.showFilterOptions = false;
    },
    prevWeek() {
      this.selectedDate[0] = new Date(
        this.selectedDate[0].setDate(this.selectedDate[0].getDate() - 7)
      );
      this.selectedDate[1] = new Date(
        this.selectedDate[1].setDate(this.selectedDate[1].getDate() - 7)
      );
    },
    nextWeek() {
      this.selectedDate[0] = new Date(
        this.selectedDate[0].setDate(this.selectedDate[0].getDate() + 7)
      );
      this.selectedDate[1] = new Date(
        this.selectedDate[1].setDate(this.selectedDate[1].getDate() + 7)
      );
    },
    prevMonth() {
      if (this.selectedDate?.month > 0) {
        this.selectedDate.month--;
      } else {
        this.selectedDate.year--;
        this.selectedDate.month = 11;
      }
    },
    nextMonth() {
      if (this.selectedDate?.month < 11) {
        this.selectedDate.month++;
      } else {
        // console.log('year');
        this.selectedDate.year++;
        this.selectedDate.month = 0;
      }
    },
    removeRouteFilter() {
      var index = this.selectedFilters.indexOf('routeValue');
      if (index > -1) {
        this.selectedFilters.splice(index, 1);
      }
      this.filterValues.routeValue = '';
    },
    removeTRFilter() {
      var index = this.selectedFilters.indexOf('trId');
      if (index > -1) {
        this.selectedFilters.splice(index, 1);
      }
      this.filterValues.routeValue = '';
    }
  }
};
</script>

<style scoped>
.nav-link {
  color: #000;
  font-weight: 600;
  font-size: 16px !important;
  line-height: 24px;
  padding: 8px 16px !important;
}
.active {
  color: #652f8f !important;
}
#filterButton {
  background: rgba(101, 47, 143, 0.15);
  color: #652f8f;
  border: none;
}
#filterButton:hover {
  background: #652f8f;
  color: #fff;
}
.filter-section {
  position: relative;
}
.filter-pop-up {
  position: absolute;
  right: 0;
  top: 45px;
  background: #fff;
  width: 350px;
  padding: 10px 10px 20px 10px;
  box-shadow: 0px 13px 31px 2px rgb(0 0 0 / 16%);
  border-radius: 4px;
  z-index: 2;
}
.filter-pop-up label {
  font-size: 14px;
  font-weight: normal;
}
.filter-pop-up .filter-fields {
  margin-bottom: 15px;
}
.filter-pop-up button {
  float: right;
}
.search-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  align-items: center;
}
.search-bar > div,
.search-bar > button {
  margin-left: 15px;
}
.date-section {
  float: left;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.date-section i {
  padding: 5px;
  cursor: pointer;
}
.date-section i:hover {
  color: #e2e555;
}
.date-section i:first-child {
  float: left;
}
.date-section i:last-child {
  float: right;
}
.filter-pop-up-close {
  overflow: hidden;
}
.filter-pop-up-close i {
  float: right;
  cursor: pointer;
}

/* Toggle Button Design Start */
* {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: none;
}

#app-cover {
  display: table;
  width: 600px;
  margin: 80px auto;
  counter-reset: button-counter;
}

.button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  float: left;
  position: relative;
  top: 50%;
  width: 76px;
  height: 38px;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.button.b2 {
  border-radius: 2px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: rgba(101, 47, 143, 0.3);
  transition: 0.3s ease all;
  z-index: 1;
}

.back-button {
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  margin-left: 15px;
  margin-bottom: 6px;
}

/* Button 1 */
#button-1 .knobs:before {
  content: 'B2C';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 30px;
  height: 30px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1.3;
  padding: 9px 4px;
  background-color: #652f8f;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1 .checkbox:checked + .knobs:before {
  content: 'B2B';
  left: 42px;
  background-color: #e2e555;
  color: #000;
}

#button-1 .checkbox:checked ~ .layer {
  background-color: rgba(226, 229, 85, 0.3);
}

#button-1 .knobs,
#button-1 .knobs:before,
#button-1 .layer {
  transition: 0.3s ease all;
}
/* Toggle Button Design End */

@media only screen and (max-width: 992px) {
  .search-bar {
    width: 100%;
    padding-top: 24px;
  }
}
</style>

<style>
.dp-custom-input {
  border: none !important;
}
.ma-bo-120 {
  margin-bottom: 120px !important;
}
.filter-options > .multiselect-dropdown {
  max-height: 120px !important;
}
</style>
